import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageComponent } from './landing-page.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PerformanceTableModule } from "./pages/performance-table/performance-table.module";
import { MapModule } from "./pages/map/map.module";
import { ChartModule } from 'angular-highcharts';
import { FormsModule } from '@angular/forms';
import { LandingPageRoutingModule } from './landing-page-routing.module';



@NgModule({
  declarations: [
    LandingPageComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PerformanceTableModule,
    MapModule,
    ChartModule,
    FormsModule,
    LandingPageRoutingModule
],
  exports:[
    LandingPageComponent
  ]
})
export class LandingPageModule { }
